import { SalonsSearchResultsComponent } from '@app/salons-search-results/salons-search-results/salons-search-results.component';
import { SalonSearchResolverService } from '@app/shared/guards';
import { Routes } from "@angular/router";

export const salonsSearchResultModuleRoutes: Routes = [
  {
    path: 'salons',
    data: { bodyCssClass: 'bjootify-salon-search' },
    children: [
      {
        path: ':cityName', component: SalonsSearchResultsComponent,
        resolve: {
          salonSearchResults: SalonSearchResolverService
        }
      },
      {
        path: ':cityName/:departmentName', component: SalonsSearchResultsComponent,
        resolve: {
          salonSearchResults: SalonSearchResolverService
        }
      },
      { path: '**', redirectTo: '/', pathMatch: 'full' },
    ]
  },
];
